<template>
  <b-modal
    ref="recaptchaModal"
    id="recaptchaModal"
    hide-header
    hide-footer
    modal-class="success-submit-modal"
    no-close-on-backdrop
    no-close-on-esc
    ignore-enforce-focus-selector=".webim-root"
  >
    <div class="modal__wrapper">
      <div class="error-message">
        <span class="error-message__icon"></span>
        <div class="error-message__info">
          <div class="error-message__text">Подтвердите, что Вы&nbsp;не&nbsp;робот.</div>
          <div class="error-message__text_subtitle">Мы обнаружили подозрительно высокое количество запросов с Вашего устройства. Чтобы продолжить, подтвердите, что Вы не робот.</div>
          <Recaptcha
            ref="bbRecaptcha"
            :publicKey="recaptchaKey"
            v-on:verified="onRecaptchaVerified"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>

import Recaptcha from '../ComponentsForm/Recaptcha.vue';

export default {
  name: 'RecaptchaModal',
  components: {
    Recaptcha,
  },
  methods: {
    async challenge() {
      // this.$refs.bbRecaptcha.reset();

      if (!this.currentChallenge) {
        this.currentChallenge = new Promise((resolve, reject) => {
          // Сохраним callbacks для того, чтобы их потом вызывать, когда пользователь решит капчу
          this.cb = { resolve, reject };
        });

        this.show();
      }
      return this.currentChallenge;
    },
    show() {
      this.$bvModal.show('recaptchaModal');
    },
    hide() {
      this.$bvModal.hide('recaptchaModal');
    },
    onRecaptchaVerified(token) {
      this.$emit('verified', token);

      if (this.currentChallenge) {
        this.cb.resolve(token);

        this.currentChallenge = null;
        this.hide();
      }
    },
  },
  data() {
    return {
      recaptchaKey: window.recaptchaKey || null,
      dataCaptcha: null,
      request: this.$root.requestLast,
    };
  },

};
</script>
<style lang="scss">
  @import './RecaptchaModal.scss';
</style>
